export const FORM_NAME = 'MemorialOrderAdd'
export const EDIT_MODAL_NAME = 'MemorialOrderEdit'
export const MODAL_NAME = 'MemorialOrderAdd'
export const ORDER_ADD_FETCHER_INSTANCE = 'MemorialOrderSubmit'
export const CHECK_DEBIT_ACCOUNT_FETCHER_NAME = 'MemorialOrderCheckDebit'
export const CHECK_CREDIT_ACCOUNT_FETCHER_NAME = 'MemorialOrderCheckCredit'
export const GET_DEBIT_ACCOUNT_BALANCE_FETCHER_NAME = 'MemorialOrderGetDebitBalance'
export const GET_CREDIT_ACCOUNT_BALANCE_FETCHER_NAME = 'MemorialOrderGetCreditBalance'
export const GET_CREDIT_ACCOUNT_VIEW_FETCHER_NAME = 'MemorialOrderGetCreditAccountView'
export const GET_DEBIT_ACCOUNT_VIEW_FETCHER_NAME = 'MemorialOrderGetDebitAccountView'
